import script from "./AdminSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&setup=true&lang=js"

import "./AdminSidebar.vue?vue&type=style&index=0&id=4608c22e&lang=css"

const __exports__ = script;

export default __exports__